import { createQuery } from 'react-query-kit';

import portalSchema from 'support/types/schema-portal';

import { fetchData } from '../../http/http';
import { BILLING_QUERY_KEY } from '../queryKeys';

type GetBillingResponse = portalSchema.paths['/v1/billing']['get']['responses']['200']['content']['application/json'];

export type BillingUsage = GetBillingResponse['data'];
export type BillingUsageGroup = BillingUsage['usage'][number];
export type BillingUsageFeature = BillingUsageGroup['features'][number];
export type BillingPeriodUsage = BillingUsage['history'][number];
export type BillingGroupName = BillingUsageGroup['group_name'];

export const useBilling = createQuery<BillingUsage, { months?: number }, Error>({
  primaryKey: BILLING_QUERY_KEY,
  queryFn: async ({ queryKey: [, variables] }) => {
    const params = variables.months ? `?months=${variables.months}` : '';
    const { data } = await fetchData<GetBillingResponse>(`/v1/billing${params}`);
    return data.data;
  },
});
